// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__252JV","radioRow":"SimpleQuestionBuilderModal_radioRow__2IvSE"};